import { makeStyles } from '@mui/styles'
import { forwardRef, useCallback } from 'react'
import { Card, IconButton, Stack, Typography } from '@mui/material'
import { SnackbarContent, CustomContentProps, useSnackbar } from 'notistack'

import CloseModalIcon from '../../assets/icons/close-modal-icon.svg'
import ExclamationIconRed from '../../assets/icons/exclamation-icon-red.svg'

const useStyles = makeStyles(() => ({
  root: {
    '@media (min-width:600px)': {
      minWidth: '344px !important'
    }
  },
  card: {
    width: '100%',
    padding: '15px',
    boxSizing: 'border-box'
  },
  typography: {
    display: 'flex',
    color: '#B91C1C',
    fontSize: '16px',
    marginLeft: '0px',
    alignItems: 'center'
  }
}))

const ErrorCreatingReport = forwardRef<HTMLDivElement, CustomContentProps>(({ id, ...props }, ref) => {
  const classes = useStyles()
  const { closeSnackbar } = useSnackbar()

  const handleDismiss = useCallback(() => {
    closeSnackbar(id)
  }, [id, closeSnackbar])

  return (
    <SnackbarContent
      ref={ref}
      className={classes.root}
    >
      <Card
        className={classes.card}
        style={{ backgroundColor: '#FEE2E2' }}
      >
        <Stack
          spacing={2}
          direction="row"
          sx={{ color: '#B91C1C', justifyContent: 'space-between' }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img
              alt="exclamation-icon"
              src={ExclamationIconRed}
              style={{ width: '32px' }}
            />
            <Typography
              variant="body2"
              className={classes.typography}
            >
              {props.message}
            </Typography>
          </div>
          <IconButton
            edge="end"
            onClick={handleDismiss}
            sx={{ color: '#525252' }}
            aria-label="toggle password visibility"
          >
            <img
              src={CloseModalIcon}
              alt="close-modal-icon"
            />
          </IconButton>
        </Stack>
      </Card>
    </SnackbarContent>
  )
})

ErrorCreatingReport.displayName = 'ErrorCreatingReport'

export default ErrorCreatingReport
